import {
  BsPencilFill,
  BsArrowRightCircleFill,
} from "react-icons/bs";
import { IoMdSkipForward } from "react-icons/io";
import { Assignment, Question } from "../../types";
import CountdownTimer from "../CountdownTimer/CountdownTimer";
import { Button } from "react-bootstrap";
import { getEmqSidebarItemClassName } from "../../utils/emqSidebarGrouping";

const AssignmentPageSidebar = (props: {
  currentQuestionIndex: number;
  setCurrentQuestionIndex: (index: number) => void;
  selectedAnswers: {
    [key: number]: number;
  };
  questions: Question[];
  assignment: Assignment | undefined;
  submit: () => void;
}) => {
  return (
    <>
      <div className="questions-progress-tracker">
        {props.assignment?.duration && (
          <div className="sticky-top-part">
            <CountdownTimer
              submit={props.submit}
              targetDateInMilliseconds={
                Number(
                  localStorage.getItem(
                    `master_q_assignment_${props.assignment.id}_start_time`,
                  ),
                ) +
                props.assignment.duration * 1000
              }
            />
          </div>
        )}
        <div className="past-questions-tracker">
          <ul>
            {props.questions.map((question, index) => {
              const questionAnswered = !!props.selectedAnswers[question.id];
              const isCurrent = index === props.currentQuestionIndex;
              const skipped = !questionAnswered && !isCurrent;
              const emqClassName = getEmqSidebarItemClassName(
                props.questions,
                index,
              );
              const showEmqLabel =
                emqClassName.includes("sidebar-q--emq-start") ||
                emqClassName.includes("sidebar-q--emq-only");

              return (
                <li
                  key={question.id}
                  id={`sidebar-question-${index}`}
                  className={emqClassName || undefined}
                  style={{
                    marginBottom:
                      index === props.questions.length - 1 &&
                      !emqClassName.includes("emq-end")
                        ? 20
                        : undefined,
                  }}
                >
                  {showEmqLabel ? (
                    <span className="sidebar-q__emq-label">EMQ</span>
                  ) : null}
                  <Button
                    size="sm"
                    id={`q${index + 1}`}
                    variant={questionAnswered ? "dark" : "light"}
                    style={{
                      fontWeight: isCurrent ? "bold" : "normal",
                      fontSize: isCurrent ? "larger" : "small",
                      transition: "all 0.3s ease",
                      boxShadow: isCurrent
                        ? "0 1px 10px rgba(0, 0, 0, 0.1)"
                        : undefined,
                    }}
                    onClick={() => {
                      props.setCurrentQuestionIndex(index);
                    }}
                  >
                    {isCurrent ? (
                      <BsArrowRightCircleFill
                        size={14}
                        style={{
                          marginRight: "5px",
                        }}
                      />
                    ) : skipped ? (
                      <IoMdSkipForward
                        size={14}
                        style={{
                          marginRight: "5px",
                          backgroundColor: "#ff9921",
                          color: "white",
                          padding: "3px",
                          borderRadius: "10px",
                        }}
                      />
                    ) : (
                      <BsPencilFill size={10} style={{ marginRight: "5px" }} />
                    )}
                    Q{index + 1}
                  </Button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default AssignmentPageSidebar;
